import { classNames } from '@utils/classNames';

interface DividerLineProps {
  className?: string;
}

export const DividerLine: React.FC<DividerLineProps> = ({ className }) => {
  return (
    <div
      className={classNames('border-b border-dark h-0', className)}
      role="separator"
    />
  );
};
